import {
  Facebook,
  Instagram,
  LinkedIn,
  Phone,
  YouTube,
} from "@material-ui/icons";
import MailIcon from "@mui/icons-material/Mail";
import {
  Box,
  Divider,
  Grid,
  Link,
  List,
  ListItem,
  ListItemText,
  Paper,
  Typography,
  styled,
} from "@mui/material";
import Image from "next/image";
import { useRouter } from "next/router";
import React from "react";

import { imagesList } from "../constants";
import { sendAnalytics } from "../utils/analyticsCommon";
import { leadActions } from "../utils/leadActions";

const CustomMobileFooter = styled(Box)(({ theme }) => ({
  display: "none",
  [theme.breakpoints.down("md")]: {
    backgroundColor: "#1C456D",
    padding: "20px 0px 12px",
    //marginTop: "24px",
    display: "block",
    ".image-section": {
      objectFit: "contain",
      position: "relative !important",
    },
    "MuiDivider-root": {
      borderWidth: "2px",
      borderColor: "#FEF8E6",
    },
    ".get-in-touch-card": {
      cursor: "pointer",
    },
    ".button-explore": {
      fontSize: "18px",
      lineHeight: "1.1em",
      fontWeight: "700",
    },
    ".svg_icons": {
      transform: "scale(1.5)",
      color: "white",
      width: "48px",
      height: "33px",
    },
    ".svg_icons_phone": {
      transform: "scale(1.5)",
      color: "white",
      width: "48px",
      height: "33px",
    },
    ".MuiTypography-root.MuiTypography-body1.heading ": {
      fontWeight: "700",
      fontSize: "22px",
      lineHeight: "1.1em",
      color: "#fff8e4",
      marginBottom: "12px",
    },
    ".MuiTypography-body1": {
      fontWeight: "700",
      fontSize: "12px",
      lineHeight: "0.8em",
      color: "#fff8e4",
    },
    ".MuiTypography-body2": {
      fontWeight: "500",
      fontSize: "18px",
      lineHeight: "1.1em",
      color: "#7F8489",
    },
    ".MuiListItem-root": {
      display: "block",
    },
    ".social-media": {
      fontSize: "15px",
      fontWeight: "400",
      lineHeight: "20px",
      color: "#fff8e4",
      fontFamily: "Montserrat,sans-serif",
    },
    ".social-media:hover": {
      fontSize: "20px",
    },
    ".MuiTypography-root.MuiTypography-body1.footer-heading": {
      fontSize: "52px",
    },
  },
}));

const MobileFooter = () => {
  const navigate = useRouter();
  const policies_url = "https://assets.turnoclub.com/developer/policies";
  return (
    <CustomMobileFooter>
      <Box style={{ display: "flex", justifyContent: "center" }}>
        <Image
          src={
            "data:image/webp;base64,UklGRkAdAABXRUJQVlA4WAoAAAAQAAAAYwIAjwAAQUxQSJIRAAANsEbbtjI11sGCJCRAhDQEd5eiqnje7u4k7e7ypN3d3d3d3V2o4BAXLEagQnAJ9iTc79Y9+3w9usb7ERGyIMmO22aYAs3gCXUIeAQeLn0T2hWXm+fIKx8jv9UV53A4yv4XgV/9WLJuRSyW+p0IzvqvbLFVXKr8SYRk/le2UBUhv5MTWeTIzSvWjlR3t/+HOQUOhyNeETM/wB3SHuKIMxC9pX4ee4ipq8q/Yw8xh9/GHmKUVvKr8OlfFdH1X93n6rb7/EySbvJjMtHgD2M5+VMIcPjDnjPo/8UkXVwMtfyuI2meFmv7VETkaNGzno9yLmrodx3XHKzFuR4V2S9p8f0/2AjL9Ic9lxIXVf4xSX8YXQP+Ffxh9wUR/rFnPyZT1f4w1pM/hcBSLn733e/+TIsY9XjWOVoUcZFFXHh+77Fis88R6+cuWO4iJRFsJO+tR2WjghNDmWj50ppducbYJp5Wddn/ZoqIUCteHPZla4ioqKjQmTOIft2o4PhwntzxbYOA2LkzKTI4aGqyb3Rr+6C91p3LUiAif2GuHre2Tmf+ncTE699opCWGiZX3KTh0MVPMh8/WWdWTmbEoLjE+boGqQI9OJ+p+4qD5dq1mU0paelpa8nzFlIyAwNmhsYnja+rrPXWTvyVziADe3C4cU8yMXLZGBEBGryIlC0sLMrOyAjR2s+mh6TiJhWVkQUCWw1FWpK1NM4uL3fFfvf/hKC9h4ZyM95tjEQHTSogU8SVACfc6iRD3Hs6SQANdLhc/c/faZx/f47lg70P++NYjq1nKdGl5XmrKnCjmFeaR2/t6VjYtq9kk+w5gitkElE0eBbMS2drj/yP2yAPKTdUgN/N6n4SjjkwzFdW5S86su9H0H3GHHuoGKVjRs6NyCvIdXZ98VDnl44CCDAL4liPjMNiqwEF8hB+zOG963LCdeRXHJBiNbNCxV3x2zaDBWO53ZhFc+Sre/8DoR57vE++kEw5uLmoRMrr7xhOMTt5LIhZ2tP6XP569m/n4Bl14ykVfGSLw6KtAi1jWuYe/dvN2/WwpBmZsGeLoa9QCuZL0teEmhZuHNRR47CVcNqvHfrh1ygR/eQC4lEWecfZDj+zQJAf53ghQniZrrXEiVBI3GyFG5iCz5/SKiiv5vuSgGzKX7PCZqLsysA0jMVfvenK9DUuuImvcAHmwSzByTlexZ9DhR7Im+ohjff7negzf/Jb7zJv3TImVDM0WL9mxQ1mZZRBcyAN3tTu4YsmkT5y9mARcoTdnVgzKolLV4SEgpPgATKwqkGnFPzz7Fh8IuHaBkLQf+I9jOq3HAlOA2e5VlScckvksv0JYp06dzOu6n77SJvAZOWl33re4zQqHvfmMrEX0CXAYAaJDI5SgJy4Y1CTgIUmJT39syVaG/qFgnVVHO4PVL84iZKrlO5R47B2a3CQr8en3VgwIlIyJYVuOjMNqEicZuYikXpe8uEWLY1KFJd550XFTJOOrnqoCMqYpe4n25jPepKCMxBJ22kM65P1DXOoPTnzI+Ao7gJUF5XwtSWsKBTVJ2SdrlJPc6+wXBzQ0wpMCU3/nK3UytMlS4ne6t08DShGHZgnxcQometd3rbmcBBL6+KkTMqxySrjvAGppZI2CEpL1SaHGuXcsSVgiMvWFf3hcBB4FafItvzXKQieEBJLMvj/3W3GH0OTfeN82AUaq0VUAL6xqa2bHAfSLy5AZbrF4Fixc8qvVhOVsocSceufOZBIwdcqGN7sDUGQ8QjoBdcKflYn2WPAvsck/8+UBUZZfJxethCgZEy3F8msnLPqjWKIOfU6ST0g+mw/Qlmz9xl+e/C2BoBLZFDaqOVFw+i94cErQJ4sI55MuMVY5/uTlkWziusaUVEg+X2JWHbqRyougs6pwVgdWkQynx6uSFE7QLhtVFInOgMPe/V/C7c1GNd5gjZvsbQSrRr6kymKzQcVevDzW+z9OimXj0Pfk+JAL52gxF8CAbTK2j1JSOpH9KnZn5dmdlcLNQWzkb9tC5JLBnIXiJdfJm+wxM1k6EUOq9/UfOGm9b2c7H+ca9tJabGeqCqA8eXBWB1bKkywjGyGfGJk8ddpUOGLEUUPRc4FZQ4iSuTYn2TGhkhRP8DhGFtyN0K4prsd+Y1UCWPQH23YGa2ZSkJjOlXhGMIZTVryGQMIGOZI4m466AAZsC7Al7YRh5XfFx+jJis0cOJnfJUUyCcjy6+aiXl3oZDi7BIunR9XrYWzEXUPTSWbGiVyD1ylwEYwzM8neJntM1SpDFU8nQkb/uBSDiIlk7KkPSmDCcpC9jWC1kJ2wFSAL+s8jEFvmWLm9SXaMIkrOSvyNlBwcBviuLiIFodGcjBrq2iN0IflXMPHrgu5ulb1MiGRAKRBybd0feFUkMXesXdDaBMD4WKWDFKscQLM1m8SjWtQfF8jVjrySUOih6lolJ81govkrTd2MNH6u7CXa20D8RIOd+DTxZ8EZRCg+6+jiIRWxtxETr37nc8Rc7EeLARQZDzaD3q6uAdpOQ11APmtrt4zNy3EGsU48Yc+CZwmHtSAlp4p8hztXsBTxwhkgTG5p83o7urzejm1ezZxmZfXrr48RkXflxhtPYoTdetNyPyxOWCITxEs2I91Hlje1tLa3+XyiUXgGI9U3KoaXt1xRfiYbm7jPdZs8hYBYjlFyNpHPOAiGwFLZPiM/VTc0thuKYgmx0XK+xU5OV14fzN8oyeEaggdiqkZNQBnYM6RkNgmm+bNPfzEZSxcbH1rupb6tI48tp5mzoPFNK0Kjee3hatJsx2fHCpwi4wGov3c9ajiabi76NNp92+by57Sbg9HTyApec3mVzUk26BQZgKMJMomLn8gwLpxvkO15op43C64hQvKpxmCqxmfiA8RLNiLU36WmpzhE4qQug4uVqpHwNI4heI8G8p21uD4aWRyeLncgfgNZgJvTlRq2boAEODjMjOcTFJP1akLywJ4hdZYDQhL3jtracZNEyQsIi5WkpoDvRQ9LbyfcDhus66SrjYOjpcv4KgknH3i1doH/yJI9DY5E1aBYNnwmsIQ1PRg509sBYC/zGCbAwfaMk9NDzYwx77pSrxnWZ0XmTSZLD4Z2Gl/uM3kknioAxTZZZ5gMnJwOcPCr+wXh5newNRK36BfESS4T5LMgQu5A/CqyQFDnKosvAYzzIp8mEwS/YtRcZfHfkfFsknbY8AagyjQuvilJGmpBnmTLg0a436y5yrJZC4ubi3bIShITIwQ335tIB2mjC5OnkgnO5eykOWGJSGHzwaENokNsBoBOsweHjjG2huRdZII9DzRcKjEYWa8Dql4OKJP7PLraDAhnNwJVErbJC8vf0EMjdE5cfMfPWwH4nlEOccqVbBArWSzNZ/RkM6GbNt60qlk4w24kJ+shJZ0gz7A5PbABSC1wcbWZ0HnPCnTZjuRyyF5iMkmRFL+nyFQtUxb87DEVuh1JLpwhXrIJQgMbJiZavKTKFBZm1Ao9eK6x0AVK9nb6jIu4tQnASftVAN2evg7fQdUSUfPZEsA0ZHehmdDNAzK/eyXBsgyn4e2BeHkaAVJLO2X5fNBlJHQGzbdVTTpbPrbj4sVJwFLlma4gPrA5vXkCKKdZqlnPLRYti+ERvdDZjR1ONiZ9n+zhYCNsxIo5B7H1EtsRJgUYR3zDd2QNS8yjKhdYbOPyglbo/FqhjI2Ybl/JJDYyrKb1lj5MAC9YF8lwUglNklVpzZvNuBOMXuj8lLKRtRq1UUQnPadeqXVFHvEpPwC2jBvGRTBOIojlF2fe/jkALeiAYjaS5tWAftO0f+kt097/gX84w03Eh0eJvVnlJms1Kolkhrs1Qj+Iha5BjMOPiO681EcZB+fRsfu8WLl5eF7WbkfAbIw1M9nefFZiTvZg/IUDOqEjGALSGdntxLNGNHJi/9jLp61/yeUslY4Ty+PCif3aPKmsZjKckHwgSYCzG8twfKJf4PrGYKDjL73n7V5Vv6igrOwPRA8OTt/kAeSS/TxVbZhCpINc+CvJfE4fjdDZYH6w6AgcvHllT0942JxZyYmWGZyFg2TJdSRVMpf4yWZknU7oCA8LmQtQSE5OVJTmyp5MJOQez+QxTTkXQ+utcQMo4hwY51zmcQET6pz994akAQGwkCk2VMgIlhNn+p8ToEmRjOLseSAblpaO2bCtrzjxrIDY7d0wcxYCWX4BVN9MzrCsQkdpdoTCtr5i5UsC6KOxFVJ9IlIBcjqCMSzL0FEMATM0QUjVPPFUQUx7M4wThxKEnA5nfLYInY+pOkstEYLqhNvIJwMc9ja60DkEqYinAthYaxk6iiFgKEIPBB0fJp2h9QhLvY0jfoeN0ZXqvR8BOJf33QXOUgWB0qlVvzxlfDKRcLS0E2Hplncen+azCh3mG+uPRGUkzPZHFwbapc69nR/Jp+7VDh+q0KGcDQmoRWoYxsNG53fbykEutCaTLyxF6KxMNFrvSJ4Kxdgy5btf+idtc1O9NaALXupKmJvxwa9wm0Q1fj1EMhTKitO5QPjxpMMKikjGJ4Nt4OzGbepI9CdxSVqGDtN9WpaP+mZsS5LNUgibrGHycDrNAU6MqljlZCL0YIL4aT7fauwwM5wCSnui3ft0DRqmHIc0EKX18QFcU59PwvjSv9eIyS9/hGp9qZu7II597rDh5FvBBORjwUf7BUF850AN6B/+CkRvh/otAQJALzF6vpDRBRf3D5LAa1J4V/9JMK/q8N6BwZB3WpE4SzLKpVplBOLY4dmNVtcLJ8hl4m0dOlfsCtn6oomqctuQlOE4+HxwFyO8vPd8sbyvqVMrgIqUhV4+1N4lm0nq6EIBoTDy/JliuVuPV/aIBeXgwN9SSRcX23qQRhcsr4dPmimUH0mPkSfPR6HN6mzg5r8gANBLTCIpkuJ9xpZp2MKev1RoL+8S3fg8emw04p3o/gvlUgdo+bXBsxu1dsg+OlEkr5Mu3ffchNL6smx05qXbuOR4k48Av1kjFwFVxeGr7pZItw8l+PEyB6QzedM1Ns5yYZM9UC08bw2cJBBfWnsTZz4UhsC49YvipeQ/S8WjXOptbz7NSIpYs6CdnymOF30zcz/1EALLNNTD+ffMkIm3D35TPZwfJOHBobdDc3bnaU/NEkbNE74eNnYqwrPOtOMX7/qNtPzmEpAkWDbV3fJKiCg2+WwXOWufwxDejBrXg/MqbJqhZt9AfrPGBaKp+8/efCpAEJ2LfW/EHXfC/oAO0SnH7m3P1JEFkn49B16T4sUfHg2WMx31eBMZXXHAKcz0b9Szwh573p6sSfmogoWpKoRN9YR8shFJ0pfG10cvRwhhrZnO88i5wQ+E7gTWvPvhow89lY2+B5864gjudfylQnwiUoEkEbfP/+ieFxaJ4Gtj9rEnnnnAxcjAJ9pV5rzAB8J46uOj7xD9FUASw7HDH8zkYw0649rD8Zm4vtJcFOvPLrk5mmmY7vNXvvYhUk8+dP+u5tdaf/LYTkfi5TOpJYQh8l7fAHyzwq+k7z495o5ocOrMbrk9+fgdiy9cYL619tkHX/oYsTVnJV2bbLSifPXGp9OikM+uTdz2Zvntgfr1HL5eT91+wVkhwHTd/ItxK+LDT+5/gskiMVH3zde1Jlr/z9+y6yWmBk29X3ymqiihidy9xNgwaCBrkIuL8QYDL4Trv73k6FDUv+57lcUm9dwL3UsOKg400Reo9lT+bE4nPndn/CmHzfK5111T+XkrwDurQZ5PbBi3pJBB3dU3f3f8mYl4TP382PdsUV778oftf9mtqCBav5m2bsXKFU2bTWfD9898UrzPrgWaBaFn3fpVtTUap4nkA0giO5A1KDQbuyp2PvVEzAEHlgUB0fPrhx8yR7z7+28bmsLz4uJjd4mmaAofpsle6unp6d3evnFzD1daRn/6/LuVyQUJ8QmRs0JCR6l3cqTH6+3q3LJ+XFszNXMbEOKamdhqOpqpzTDn6mU27+Cak2pOvdR//NHyrIK8+Nlz5sxkpXd4cHPz+jojZ4oSVlA4IIgLAADQPQCdASpkApAAPpFEm0q/v6IhqLFZ4/ASCWJu4WS+Y/5h+AHrc+r/AD9ZkXuKH+E/MvwKpF9z/rn7Ef4r9t+mW52+t/m32EdFkgr1W9zvyP3H/N3/D/5n2F/2v1B/6//Tv+T7dPQZ/a/QF+yf/W/xXu2f5v/e/zj3Q/tD+tHwAfxz+5f/r2kf9v///cp/p3/S/f/4BP5B/cPv/+Mj9gP/R8k37ifuv7R3/7/6n//+AD0AP+51w/Rb+R/g3+B/6D96BWUfdTaQveIRZgXpgIpfM/+ZTkjkAZJnmWgUyOPb7NE8SKXzP/mU5I5AGSZ5lnler0MdfT7NAxpJ/7BB5T4cy0sMlxmzWJkArBQuaR/9CQAOFKt2/CdIiUW/+m7oXiu0NlLRa6tCr5XhYf8TzL9HCOFH0m+FSLwodvE0AMkzYAX454fBo8nAN7sHuKC4psSogF5ef9ys+MvzC6PI24Nm01kM0twz+lbWMLBovmWF6OGf0rdX2Nouq1qNB1DeXV1iSXMACMFIvProYyKClzUA8EHdavA/oiBFgGhlZfC+Gs18w2jD0roq+Yzba2r/1LugwrTI4f+BN5p/A1A8uEU1q8z3IU5cvx6lJPb6JmjGYHYWA9VrAO4E3nuiIF7TRhduNHx6iBPcgyg+DO02GRyS17GH4lrsAAD9yExVO+X+0mbf59+U0tJiYkVFdj+QoSRP8nwwUYMbxX2PRoarqZ2W2EO25yloqIrTyXl65LUwzlJzURb676EG07wZqVUsejHKf2tmNGq5wgSNbHjwsxAiiVbor3aoAAAAhMalYtuicJlXuOoceYlJowEbi5UTcjYXYPtFom7ueA9G0/3J0tP/+lXf/7IfTFobNPAgccxLCUALfQMAAAAe7S2TyHU4ZpSPqV+eNALroIhT89QLI0MrU/joJr99Y6hjir98VgX+6+u7tpYAnQhBH7zzHZ6A3/6EBgmKJwUdKTI3HQJYhdi0XavM1TU7xfq9bRq/kMGTOLyH0DFkGruHYfCfNIhK5wUkr3BTalO2AAPbsioD+Duy0XRQtcT/8wSG3/7CA3qXwrvl4LDbbnCnHYEBVo6jE9WII0LBZTeUQuJiF6hYl6NO+5hxHHlHlYTog9FfMoga4tKZquXe9NEZr2DXTvfek1JCGTMqXmrBCv8GecsB7xnUphJqWrBrc7JL3ntpbLTSjeySH4ezZY2aSs8FgCSZI8xCn68iuo1lDs822tDA8Fz0DVAY5VuDQI7rtE0NWYvJtLakvDh9bXkfoPr9u3+pGfExJ5JX5GIgT25SHpcNirSxGoAkTmFURp3XY022VBdr763NQ0Xv/GQJv3r55ERpssmF5aKKIVCZh8kkv1xN0x2876iIUU5lLmCR+/gZ4JdG/tMJ1RqAspubJ3rvY+3kM+EhVrMEx+zALoCCwqa/AOJ7oEfqj0v2Y1rVh4Bw2r/g5XQIE4jvvy237pJiWSM7DcB9GO1oBD690FE3gPKwKNCZQbA9Eai7HsAwNMAFWNSjgxbm16wOWkaC9EVIyzMzTTbOQQFNO3EQdLi78MVn5cl4k2a5MBiBUAhkth1OZH7FY2BQJZXHlipoDjkH+O4EPxEPGJTVVuAtCDa20LTRy6KkyYiThCWq/+UQRncbf+uQvYblMm4BWj3sKFpQP+7qe/qMA4y+TqH1RskU42z0FN0B6aUHJVS2Nxf9WOf46g+MjRFoPEPaCziBngABlI97GX3jJjJE2n8QtRg5BVlUZNtQJIenxo6YpkE/QeV6pJWZcBxgSMR3AZUm9FR78dN6MfJfXp5cqJgC8bbFGExnvmUY+ZnFhCbGATd+W/fi7D0JNqQE8rQ/haO8/U/iZ3nMNXNhYKhA4RGl7t5cFpb44VE8h8TvKsUyASt3k6chEwz8WowxHcJU7X7aGHkmWRZq0ftTQhsBXgZpMCTIFgDcWmutNku2z2YLGwEfq32mfJs+JQZzmgQVw//+y3w9ldz1pNsMffGgRPfQbPzyXjTVy4arDCxSCuEDxoJvEdMMjKCIye8P12dUa+HoVHX+zFn1Vpc/skjaPCny/sllmA0ohf71KmWBAgpyT/5HH5AkWSaQiJuf7Fvl0JTAmdSe1oQKo0KJv62e+mfHVfqXzxlH3IW2cI+i3VtS7bCw77w8106NPTxfOIQ8EMznoiGzmFXLyosABHVYGSlS1BptpK8DWvv6MEtFAfsEoUzs1A1S73lmGt1YOotvfWR5/jzfP0R7OWz87PvgFfYV1FvFuwM9l77+OWHs+sogq4rz/IGPohMJyxXWsKuVGohsqzEjkL4fGZE5k9F9zlXsYclF+IGRMhStTGv9hEJZkqZAIahW5tKOT2sLLzgb07BvAmGFTaD32jqXsF5+IJvH4OxKHo1789tXte0FjcnQqhKs5Pw3WLo+1NDzGkQKUqs0MhmENDxpqpj0qayijeFmlBo0CAL4JpFEZBFPdifH0EsfCugyF4JsueFYpeHbDO/mKWW+AJEdBwgcgC7DMIsORcb0hfqNLP/OFC0Q9SdaHbIWzoIic0gwQ1Y3l0VJ5RqBAjHHCegf9OJsFENM16IekbLq5ojvyP1X16TgZV9GsLosFP6hdLrEBs2NDlh/yGk3vOcz9hUD/u3E2xwqJ5xzRdqn4A47DcM+zNE3iT4fP8pV7srP6Y48kVJ1YLIWtIlaNrvqQZ1csa0BOL7ZYl7pwdTpS6pnOL9mwKZ4bf/fngQ4w1/0CJj//9KX5CzgoIRmQ/WXV/zUHS5lA61r/9yCEjfsP+/GpQSYcR/GQ6071nBbCXuw/9A76tx6C3cegMlgC3vVrcGUsPXey8NQRN57bDtmbpDX10YSRqgABNQL3yG7wE64NEPNf9w/VpU44IHPUWMELxB7JMwhaETJySX8hEpwiE4xGbEv5/QDw7vYcu54uVv6RW5/sD8WD/orFDVC0e/twQPca1TvNi53Csvy0CifKscR1LldEHmmgcjW+v1jdBpXydZWlB6l98xCGIY3kWJ/fNuspQAT4In/+yuwX7/hrDbKVHzBhfzol2Aa/nALKQ3//32MbRjj2t1d7PuWHcm1ruqWnlgcYLjZetjSVd3zsPlZtagLYgbxYnJfoA3nfZSU+ZVboZBgz9iRxteKXvbvgMwvhK1lB42+XFR0pQgKmWOgR0MJvZOjjikVuUVhcMRFSJTuHbDO/daZ8zsTi6GBgAcbrE7mEX02+rJVpkmMF5bxXAZhfngW8OSzCr70iOy7NH3/NvMcDpckQk6lBDL/a5UvpWToFGR+Dx/qhTHk6RqXaA7hc9bASPxMWo41XVPqbnUzK8OTe2dhyIghf3E4TM9fIuBqrG5cdV0v84ijgmyqSy046ve2GL4CCJph65nZNyvFk8sX6WY/jSvgnx8jlDOipn/6Dp//rVGy3ZJ+nHSQGu156NZoJaYNYoCTnsdWr+T4x1+0H2et3Z2Soy6ZgN2IY0oFqoLvKwAnkyCIDykMPBlvE8oVjMFZMNi/e8GhbNlrCZg+9pIkViWtPeFhd5GTUi94YSSR0ZtdXPk8/T830HrIWQQiZZjEh0gETKTgTVnNayJOglACE74Tdkp3tOkeNaH5BW8cMYgKM/0Gra7GCIPrZu2yRdQLkgblC2ocxij5zvK2xCR5WFV3bqJohY4EhZ/26k7GErbq160gi3yEzWW0wADb4Fkno6fjHoGBfTmhmCJzHauvG8fNtjo0SDBmrK0jPyv7hkiss6gB0k6vsE6wY3ZPWwxWehHWuMFVbwDbSKFmQvA2H0NuUooGl/I8gY4cUFlv7tutUdhKK35XRzB0PCKNMDES1RbhrAQislP08JwNAJN4w9SDrCw/IiSQQQOMIrq9/cPSO9qIvaAcLO5IG7K5xkYnr1JblLKpLiY1FcddF2t4TexNsEvMrDPGFly9ZGrfDBv8udcs2jTrP8ophOOGJ5kAAAA="
          }
          width="100"
          height={"25"}
          alt="Turno Logo"
          className={"image-section"}
        />
      </Box>
      <Box style={{ padding: "20px" }}>
        <Grid container>
          <Grid item xs={6}>
            <List style={{ padding: "0px" }}>
              <ListItem sx={{ padding: "8px 0px" }}>
                <Link
                  target="_self"
                  href={`${process.env.NEXT_PUBLIC_BASE_URL}/`}
                  hrefLang={"en"}
                  rel="noreferrer"
                  underline="none"
                  onClick={() => {
                    let payload = { option_selected: "home_page" };
                    sendAnalytics("footer_page_clicked", payload, "en");
                  }}
                >
                  <ListItemText className="sub-data" primary={"Home"} />
                </Link>
              </ListItem>
              <ListItem sx={{ padding: "8px 0px" }}>
                <Link
                  target="_self"
                  href={`${process.env.NEXT_PUBLIC_BASE_URL}/referral`}
                  hrefLang={"en"}
                  rel="noreferrer"
                  underline="none"
                  onClick={() => {
                    let payload = { option_selected: "footer_referral" };
                    sendAnalytics("footer_page_clicked", payload, "en");
                  }}
                >
                  <ListItemText
                    className="sub-data"
                    primary={"Refer your friend"}
                  />
                </Link>
              </ListItem>
              <ListItem sx={{ padding: "8px 0px" }}>
                <Link
                  target="_self"
                  href={`${process.env.NEXT_PUBLIC_BASE_URL}/aboutus`}
                  hrefLang={"en"}
                  rel="noreferrer"
                  underline="none"
                  onClick={() => {
                    let payload = { option_selected: "footer_aboutus" };
                    sendAnalytics("footer_page_clicked", payload, "en");
                  }}
                >
                  <ListItemText className="sub-data" primary={"About Us"} />
                </Link>
              </ListItem>
              <ListItem sx={{ padding: "8px 0px" }}>
                <Link
                  target="_self"
                  href={`${process.env.NEXT_PUBLIC_BASE_URL}/contactus`}
                  hrefLang={"en"}
                  rel="noreferrer"
                  underline="none"
                  onClick={() => {
                    let payload = { option_selected: "footer_contactus" };
                    sendAnalytics("footer_page_clicked", payload, "en");
                  }}
                >
                  <ListItemText className="sub-data" primary={"Contact Us"} />
                </Link>
              </ListItem>

              <ListItem sx={{ padding: "8px 0px" }}>
                <Link
                  target="_blank"
                  hrefLang={"en"}
                  rel="noreferrer"
                  underline="none"
                  onClick={() => {
                    let payload = { option_selected: "privacy_policy" };
                    sendAnalytics("footer_policy_clicked", payload, "en");

                    navigate.push("/privacy-policy");
                  }}
                >
                  <ListItemText
                    className="sub-data"
                    primary={"Privacy Policy"}
                  />
                </Link>
              </ListItem>
              <ListItem sx={{ padding: "8px 0px" }}>
                <Link
                  target="_blank"
                  href={`${policies_url}/refund%2Bpolicy.pdf`}
                  hrefLang={"en"}
                  rel="noreferrer"
                  underline="none"
                  onClick={() => {
                    let payload = { option_selected: "refund_policy" };
                    sendAnalytics("footer_policy_clicked", payload, "en");
                  }}
                >
                  <ListItemText
                    className="sub-data"
                    primary={"Refund Policy"}
                  />
                </Link>
              </ListItem>
              <ListItem sx={{ padding: "8px 0px" }}>
                <Link
                  target="_blank"
                  href={`${policies_url}/Referral+Policy.pdf`}
                  hrefLang={"en"}
                  rel="noreferrer"
                  underline="none"
                  onClick={() => {
                    let payload = { option_selected: "referral_policy" };
                    sendAnalytics("footer_policy_clicked", payload, "en");
                  }}
                >
                  <ListItemText
                    className="sub-data"
                    primary={"Referral Policy"}
                  />
                </Link>
              </ListItem>
              <ListItem sx={{ padding: "8px 0px" }}>
                <Link
                  target="_self"
                  href={`${process.env.NEXT_PUBLIC_BASE_URL}/lending-partners`}
                  hrefLang={"en"}
                  rel="noreferrer"
                  underline="none"
                >
                  <ListItemText
                    className="sub-data"
                    primary={"Lending Partners"}
                  />
                </Link>
              </ListItem>
            </List>
          </Grid>

          <Grid item xs={6}>
            <List style={{ padding: "0px" }}>
              <ListItem sx={{ padding: "8px 0px" }}>
                <Link
                  target="_self"
                  href={`${process.env.NEXT_PUBLIC_BASE_URL}/electric-commercial-vehicles`}
                  hrefLang={"en"}
                  rel="noreferrer"
                  underline="none"
                  onClick={() => {
                    let payload = { option_selected: "vehicle_page" };
                    sendAnalytics("footer_page_clicked", payload, "en");
                  }}
                >
                  <ListItemText
                    className="sub-data"
                    primary={"Electric Commercial Vehicles"}
                  />
                </Link>
              </ListItem>
              <ListItem sx={{ padding: "8px 0px" }}>
                <Link
                  target="_self"
                  href={`${process.env.NEXT_PUBLIC_BASE_URL}/electric-commercial-vehicles/Piaggio`}
                  hrefLang={"en"}
                  rel="noreferrer"
                  underline="none"
                  onClick={() => {
                    let payload = { option_selected: "vehicle_piaggio" };
                    sendAnalytics("footer_page_clicked", payload, "en");
                  }}
                >
                  <ListItemText className="sub-data">
                    <Typography
                      style={{
                        fontWeight: "400",
                      }}
                    >
                      Piaggio
                    </Typography>
                  </ListItemText>
                </Link>
              </ListItem>

              <ListItem sx={{ padding: "8px 0px" }}>
                <Link
                  target="_self"
                  href={`${process.env.NEXT_PUBLIC_BASE_URL}/electric-commercial-vehicles/Mahindra`}
                  hrefLang={"en"}
                  rel="noreferrer"
                  underline="none"
                  onClick={() => {
                    let payload = { option_selected: "vehicle_mahindra" };
                    sendAnalytics("footer_page_clicked", payload, "en");
                  }}
                >
                  <ListItemText className="sub-data">
                    <Typography
                      style={{
                        fontWeight: "400",
                      }}
                    >
                      Mahindra
                    </Typography>
                  </ListItemText>
                </Link>
              </ListItem>
              <ListItem sx={{ padding: "8px 0px" }}>
                <Link
                  target="_self"
                  href={`${process.env.NEXT_PUBLIC_BASE_URL}/electric-commercial-vehicles/Etrio`}
                  hrefLang={"en"}
                  rel="noreferrer"
                  underline="none"
                  onClick={() => {
                    let payload = { option_selected: "vehicle_ETRIO" };
                    sendAnalytics("footer_page_clicked", payload, "en");
                  }}
                >
                  <ListItemText className="sub-data">
                    <Typography
                      style={{
                        fontWeight: "400",
                      }}
                    >
                      Etrio
                    </Typography>
                  </ListItemText>
                </Link>
              </ListItem>
              <ListItem sx={{ padding: "8px 0px" }}>
                <Link
                  target="_self"
                  href={`${process.env.NEXT_PUBLIC_BASE_URL}/electric-commercial-vehicles/OSM`}
                  hrefLang={"en"}
                  rel="noreferrer"
                  underline="none"
                  onClick={() => {
                    let payload = { option_selected: "vehicle_OSM" };
                    sendAnalytics("footer_page_clicked", payload, "en");
                  }}
                >
                  <ListItemText className="sub-data">
                    <Typography
                      style={{
                        fontWeight: "400",
                      }}
                    >
                      OSM
                    </Typography>
                  </ListItemText>
                </Link>
              </ListItem>

              <ListItem sx={{ padding: "8px 0px" }}>
                <Link
                  target="_self"
                  href={`${process.env.NEXT_PUBLIC_BASE_URL}/electric-commercial-vehicles/Euler`}
                  hrefLang={"en"}
                  rel="noreferrer"
                  underline="none"
                  onClick={() => {
                    let payload = { option_selected: "vehicle_Euler" };
                    sendAnalytics("footer_page_clicked", payload, "en");
                  }}
                >
                  <ListItemText className="sub-data">
                    <Typography
                      style={{
                        fontWeight: "400",
                      }}
                    >
                      Euler
                    </Typography>
                  </ListItemText>
                </Link>
              </ListItem>
              <ListItem sx={{ padding: "8px 0px" }}>
                <Link
                  target="_self"
                  href={`${process.env.NEXT_PUBLIC_BASE_URL}/electric-passenger-vehicles/Montra/Montra-Super-Auto`}
                  hrefLang={"en"}
                  rel="noreferrer"
                  underline="none"
                  onClick={() => {
                    let payload = { option_selected: "vehicle_Montra" };
                    sendAnalytics("footer_page_clicked", payload, "en");
                  }}
                >
                  <ListItemText className="sub-data">
                    <Typography
                      style={{
                        fontWeight: "400",
                      }}
                    >
                      Montra Super Auto
                    </Typography>
                  </ListItemText>
                </Link>
              </ListItem>
              <ListItem sx={{ padding: "8px 0px" }}>
                <Link
                  target="_self"
                  href={`${process.env.NEXT_PUBLIC_BASE_URL}/electric-passenger-vehicles/Piaggio/E-City-FX`}
                  hrefLang={"en"}
                  rel="noreferrer"
                  underline="none"
                  onClick={() => {
                    let payload = {
                      option_selected: "vehicle_Piaggio_E-City-Fx",
                    };
                    sendAnalytics("footer_page_clicked", payload, "en");
                  }}
                >
                  <ListItemText className="sub-data">
                    <Typography
                      style={{
                        fontWeight: "400",
                      }}
                    >
                      Piaggio E City Fx
                    </Typography>
                  </ListItemText>
                </Link>
              </ListItem>
              <ListItem sx={{ padding: "8px 0px" }}>
                <Link
                  target="_self"
                  href={`${process.env.NEXT_PUBLIC_BASE_URL}/electric-passenger-vehicles/Bajaj/BajajRETEC`}
                  hrefLang={"en"}
                  rel="noreferrer"
                  underline="none"
                  onClick={() => {
                    let payload = { option_selected: "vehicle_BajajRETEC" };
                    sendAnalytics("footer_page_clicked", payload, "en");
                  }}
                >
                  <ListItemText className="sub-data">
                    <Typography
                      style={{
                        fontWeight: "400",
                      }}
                    >
                      Bajaj RE E TEC 9.0
                    </Typography>
                  </ListItemText>
                </Link>
              </ListItem>
              <ListItem sx={{ padding: "8px 0px" }}>
                <Link
                  target="_self"
                  href={`${process.env.NEXT_PUBLIC_BASE_URL}/electric-passenger-vehicles/Mahindra/MahindraTreoPlus`}
                  hrefLang={"en"}
                  rel="noreferrer"
                  underline="none"
                  onClick={() => {
                    let payload = {
                      option_selected: "vehicle_MahindraTreoPlus",
                    };
                    sendAnalytics("footer_page_clicked", payload, "en");
                  }}
                >
                  <ListItemText className="sub-data">
                    <Typography
                      style={{
                        fontWeight: "400",
                      }}
                    >
                      Mahindra Treo Plus
                    </Typography>
                  </ListItemText>
                </Link>
              </ListItem>
              <ListItem sx={{ padding: "8px 0px" }}>
                <Link
                  target="_self"
                  href={`${process.env.NEXT_PUBLIC_BASE_URL}/mysites.xml`}
                  hrefLang={"en"}
                  rel="noreferrer"
                  underline="none"
                >
                  <ListItemText className="sub-data" primary={"Sitemap"} />
                </Link>
              </ListItem>

              <ListItem sx={{ padding: "8px 0px" }}>
                <Link
                  target="_self"
                  href={`https://turno.keka.com/careers`}
                  hrefLang={"en"}
                  rel="noreferrer"
                  underline="none"
                >
                  <ListItemText className="sub-data" primary={"Careers"} />
                </Link>
              </ListItem>
            </List>
          </Grid>
        </Grid>
        <Box>
          <List style={{ padding: "0px" }}>
            <ListItem sx={{ padding: "8px 0px" }}>
              <Link
                target="_blank"
                href={`${policies_url}/Consent+Withdrawal+Process.docx.pdf`}
                hrefLang={"en"}
                rel="noreferrer"
                underline="none"
                onClick={() => {
                  let payload = {
                    option_selected: "consent_withdrawal_process",
                  };
                  sendAnalytics("footer_policy_clicked", payload, "en");
                }}
              >
                <ListItemText
                  className="sub-data"
                  primary={"Consent Withdrawal Process"}
                />
              </Link>
            </ListItem>
            <ListItem sx={{ padding: "8px 0px" }}>
              <Link
                target="_blank"
                href={`${policies_url}/Grievance+Redressal+Policy.pdf`}
                hrefLang={"en"}
                rel="noreferrer"
                underline="none"
                onClick={() => {
                  let payload = {
                    option_selected: "grievance_redressal_policy",
                  };
                  sendAnalytics("footer_policy_clicked", payload, "en");
                }}
              >
                <ListItemText
                  className="sub-data"
                  primary={"Grievance Redressal Policy"}
                />
              </Link>
            </ListItem>
            <ListItem sx={{ padding: "8px 0px" }}>
              <Link
                target="_blank"
                href={`${policies_url}/Buyback+and+loyalty+reward+policy.pdf`}
                hrefLang={"en"}
                rel="noreferrer"
                underline="none"
                onClick={() => {
                  let payload = {
                    option_selected: "buyback_and_loyalty_reward_policy",
                  };
                  sendAnalytics("footer_policy_clicked", payload, "en");
                }}
              >
                <ListItemText
                  className="sub-data"
                  primary={"Buyback and Loyalty Reward Policy"}
                />
              </Link>
            </ListItem>
            <ListItem sx={{ padding: "8px 0px" }}>
              <Link
                target="_blank"
                href={`https://decentro.tech/terms/`}
                hrefLang={"en"}
                rel="noreferrer"
                underline="none"
                onClick={() => {
                  let payload = {
                    option_selected: "decentro_terms_and_conditions",
                  };
                  sendAnalytics("footer_policy_clicked", payload, "en");
                }}
              >
                <ListItemText
                  className="sub-data"
                  primary={"Decentro terms and conditions"}
                />
              </Link>
            </ListItem>

            <ListItem sx={{ padding: "8px 0px" }}>
              <Link
                target="_blank"
                href={`${process.env.NEXT_PUBLIC_BASE_URL}/terms-and-conditions`}
                hrefLang={"en"}
                rel="noreferrer"
                underline="none"
                onClick={() => {
                  let payload = {
                    option_selected: "terms_and_conditions",
                  };
                  sendAnalytics("footer_policy_clicked", payload, "en");
                }}
              >
                <ListItemText
                  className="sub-data"
                  primary={"Terms & Conditions"}
                />
              </Link>
            </ListItem>
          </List>
        </Box>
      </Box>
      <Box style={{ padding: "0px 20px" }}>
        <Divider sx={{ borderColor: "#FFFFFF" }} />
      </Box>
      <Box style={{ padding: "20px 36px" }}>
        <Typography
          style={{
            lineHeight: "15px",
            fontSize: "14px",
            fontWeight: "700",
            paddingBottom: "10px",
          }}
        >
          For Any Assistance
        </Typography>
        <Typography
          style={{ lineHeight: "20px", fontSize: "11px", fontWeight: "700" }}
        >
          Blubble Private Limited,
        </Typography>
        <Typography
          style={{ lineHeight: "20px", fontSize: "11px", fontWeight: "500" }}
        >
          {" "}
          Industrial Plot Bearing No 7-A1
        </Typography>
        <Typography
          style={{ lineHeight: "20px", fontSize: "11px", fontWeight: "500" }}
        >
          {" "}
          3rd Cross Rd, Devasandra Industrial Estate,
        </Typography>
        <Typography
          style={{ lineHeight: "20px", fontSize: "11px", fontWeight: "500" }}
        >
          {" "}
          Krishnarajapura, Near VR mall, Bengaluru, Karnataka
        </Typography>
        <Typography
          style={{ lineHeight: "20px", fontSize: "11px", fontWeight: "500" }}
        >
          560048
        </Typography>

        <Grid container sx={{ padding: "20px 0px 0px" }}>
          <Grid item xs={6}>
            <Link
              href={
                navigate?.pathname === "/enquiry"
                  ? "tel:08105502233"
                  : navigate?.pathname === "/enquiry/electric-passenger"
                  ? "tel:918045446788"
                  : "tel:08047482233"
                // : "tel:08047482233"
              }
              hrefLang={"en"}
              target="_blank"
              rel="noreferrer"
              underline="none"
              onClick={() => {
                leadActions("CLICK_WHATSAPP_CHAT");
                let payload = { option_selected: "phone" };
                sendAnalytics("footer_get_in_touch_clicked", payload, "en");
              }}
            >
              <Paper
                className="get-in-touch-card"
                sx={{
                  background: "#0A486F",

                  p: "16px 8px",
                  width: "150px !important",
                  display: "flex",
                  gap: "10px",
                  mb: "16px",
                  alignItems: "center",
                  borderRadius: "5px",
                }}
              >
                <Box
                  style={{
                    background: "#ffffff",
                    borderRadius: "50%",
                    width: "20px",
                    height: "20px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <Phone
                    className="svg_icons_phone"
                    style={{ width: "12px", height: "12px", color: "black" }}
                  />
                </Box>
                <Box
                  sx={{
                    color: "#E8345E",
                    fontSize: "12px",
                    lineHeight: "1.1em",
                    fontWeight: "600",
                  }}
                >
                  {"Call us"}
                  <Typography className="get-in-touch-typo">
                    {navigate?.pathname === "/enquiry"
                      ? "08105502233"
                      : navigate?.pathname === "/enquiry/electric-passenger"
                      ? "918045446788"
                      : "08047482233"}
                  </Typography>
                </Box>
              </Paper>
            </Link>
          </Grid>
          <Grid item xs={6}>
            <Paper
              className="get-in-touch-card"
              sx={{
                background: "#0A486F",
                p: "16px 8px",
                width: "150px !important",
                display: "flex",
                gap: "10px",
                mb: "16px",
                alignItems: "center",
                borderRadius: "5px",
              }}
              onClick={() => {
                let payload = { option_selected: "email" };
                sendAnalytics("footer_get_in_touch_clicked", payload, "en");
              }}
            >
              <Box
                style={{
                  background: "#ffffff",
                  borderRadius: "50%",
                  width: "20px",
                  height: "20px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                {" "}
                <MailIcon
                  className="svg_icons"
                  style={{ width: "12px", height: "12px", color: "black" }}
                />
              </Box>

              <Box
                sx={{
                  color: "#E8345E",
                  fontSize: "12px",
                  lineHeight: "1.1em",
                  fontWeight: "600",
                }}
              >
                {"Email us"}
                <Typography className="get-in-touch-typo">
                  {"sales@turno.club"}
                </Typography>
              </Box>
            </Paper>
          </Grid>
        </Grid>
      </Box>
      <Box style={{ padding: "0px 20px" }}>
        <Divider sx={{ borderColor: "#FFFFFF" }} />
      </Box>
      {/* social media */}
      <Box style={{ padding: "0px 36px" }}>
        <Grid container>
          <Grid item xs={6}>
            <List>
              <ListItem sx={{ padding: "0px 0px" }}>
                <Link
                  target="_blank"
                  href="https://www.instagram.com/turnoclub/"
                  hrefLang={"en"}
                  rel="noreferrer"
                  underline="none"
                  onClick={() => {
                    let payload = { option_selected: "instagram" };
                    sendAnalytics("footer_social_media_clicked", payload, "en");
                  }}
                >
                  <Box
                    component="span"
                    className="social-media"
                    sx={{
                      display: "flex",
                      gap: "8px",
                      p: { xs: "5px 0px", md: "unset" },
                      alignItems: "center",
                    }}
                  >
                    <Box
                      style={{
                        width: "20px",
                        height: "20px",
                        background: "#ffffff",
                        borderRadius: "50%",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <Instagram
                        style={{
                          width: "14px",
                          height: "14px",
                          color: "#000000",
                        }}
                      />
                    </Box>

                    {"Instagram"}
                  </Box>
                </Link>
              </ListItem>
              <ListItem sx={{ padding: "0px 0px" }}>
                <Link
                  target="_blank"
                  href="https://www.linkedin.com/company/turnoclub/"
                  hrefLang={"en"}
                  rel="noreferrer"
                  underline="none"
                  onClick={() => {
                    let payload = { option_selected: "Linkedin" };
                    sendAnalytics("footer_social_media_clicked", payload, "en");
                  }}
                >
                  <Box
                    component="span"
                    className="social-media"
                    sx={{
                      display: "flex",
                      gap: "8px",
                      p: { xs: "5px 0px", md: "unset" },
                      alignItems: "center",
                    }}
                  >
                    <Box
                      style={{
                        width: "20px",
                        height: "20px",
                        background: "#ffffff",
                        borderRadius: "50%",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <LinkedIn
                        style={{
                          width: "14px",
                          height: "14px",
                          color: "#000000",
                        }}
                      />
                    </Box>

                    {"LinkedIn"}
                  </Box>
                </Link>
              </ListItem>
            </List>
          </Grid>
          <Grid item xs={6}>
            <List>
              <ListItem sx={{ padding: "0px 0px" }}>
                <Link
                  target="_blank"
                  href="https://www.facebook.com/turno.club/"
                  hrefLang={"en"}
                  rel="noreferrer"
                  underline="none"
                  onClick={() => {
                    let payload = { option_selected: "facebook" };
                    sendAnalytics("footer_social_media_clicked", payload, "en");
                  }}
                >
                  <Box
                    component="span"
                    className="social-media"
                    sx={{
                      display: "flex",
                      gap: "8px",
                      p: { xs: "5px 0px", md: "unset" },
                      alignItems: "center",
                    }}
                  >
                    <Box
                      style={{
                        width: "20px",
                        height: "20px",
                        background: "#ffffff",
                        borderRadius: "50%",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <Facebook
                        style={{
                          width: "14px",
                          height: "14px",
                          color: "#000000",
                        }}
                      />
                    </Box>
                    {"Facebook"}
                  </Box>
                </Link>
              </ListItem>
              <ListItem sx={{ padding: "0px 0px" }}>
                <Link
                  target="_blank"
                  href="https://www.youtube.com/channel/UCZDxqBUyszLlgIGMnc1pjMA"
                  hrefLang={"en"}
                  rel="noreferrer"
                  underline="none"
                  onClick={() => {
                    let payload = { option_selected: "youtube" };
                    sendAnalytics("footer_social_media_clicked", payload, "en");
                  }}
                >
                  <Box
                    component="span"
                    className="social-media"
                    sx={{
                      display: "flex",
                      gap: "8px",
                      p: { xs: "5px 0px", md: "unset" },
                      alignItems: "center",
                    }}
                  >
                    <Box
                      style={{
                        width: "20px",
                        height: "20px",
                        background: "#ffffff",
                        borderRadius: "50%",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <YouTube
                        style={{
                          width: "14px",
                          height: "14px",
                          color: "#000000",
                        }}
                      />
                    </Box>
                    {"Youtube"}
                  </Box>
                </Link>
              </ListItem>
            </List>
          </Grid>
        </Grid>
        <Box style={{ textAlign: "center", width: "300px" }}>
          {" "}
          <Typography
            style={{ fontSize: "12px", fontWeight: "400", lineHeight: "14px" }}
          >
            © Blubble Private Limited | All rights reserved | The Turno brand is
            owned by Blubble Private Limited
          </Typography>
        </Box>
      </Box>
    </CustomMobileFooter>
  );
};

export default MobileFooter;
